import { trainingDays, withValidMeals } from "../components/services/ServiceControls";

// All state transitions for one participant's optional services.
export function useServicesEditor(participant, onChange) {
  const svc = participant.services;
  const setServices = (services) => onChange({ ...participant, services });
  const update = (patch) => setServices({ ...svc, ...patch });
  const td = trainingDays(svc);

  const setTrainingType = (key, type) => {
    const next = { ...svc[key], type, days: type === "individual" ? (svc[key].days || {}) : {} };
    setServices(withValidMeals({ ...svc, [key]: next }));
  };

  const cycleDay = (key, day) => {
    const days = { ...(svc[key].days || {}) };
    const nxt = (days[day] || 0) + 1;
    if (nxt > 2) delete days[day]; else days[day] = nxt;
    setServices(withValidMeals({ ...svc, [key]: { ...svc[key], days } }));
  };

  const setFeedbackType = (type) => {
    if (svc.development_package && type !== "none") return;
    update({ feedback: { type, days: type === "individual" ? (svc.feedback.days || {}) : {} } });
  };

  const toggleFeedbackDay = (day) => {
    const days = { ...(svc.feedback.days || {}) };
    if (days[day]) delete days[day]; else days[day] = 1;
    update({ feedback: { ...svc.feedback, days } });
  };

  const toggleDevelopment = () => {
    if (svc.development_package) { update({ development_package: false }); return; }
    update({ development_package: true, feedback: { type: "none", days: {} } });
  };

  const toggleMeal = (day) => {
    if (!td.has(day)) return;
    const days = new Set(svc.meals.days || []);
    if (days.has(day)) days.delete(day); else days.add(day);
    update({ meals: { days: [...days].sort((a, b) => a - b) } });
  };

  const setDietary = (v) => onChange({ ...participant, meal_dietary: v });

  return { svc, td, setTrainingType, cycleDay, setFeedbackType, toggleFeedbackDay, toggleDevelopment, toggleMeal, setDietary };
}
